import React, { useState } from "react";
import "./ContactUs.css"; // Include your CSS styles
import mapPlaceholder from "../resources/map-placeholder.jpg";

const ContactUs = () => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  const handleMapLoad = () => {
    setIsMapLoaded(true);
  };

  return (
    <>
      <div className="contact-page page">
        <h1>KEEP IN TOUCH</h1>
        <p>
          We always feel pleasure to help our clients to build their financial
          health strong. You can reach us by any of the below ways.
        </p>

        <div className="contact-container">
          {/* Contact Info Section */}
          <div className="contact-info">
            <div className="contact-col">
              {/* Call Us Section */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-phone-call"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
                <path d="M15 7a2 2 0 0 1 2 2" />
                <path d="M15 3a6 6 0 0 1 6 6" />
              </svg>
              <h2>Call Us</h2>
              <p>
                Feel free to call us on +91 9415762826
                <br />
                Monday - Friday, 9:30 AM - 5:30 PM
              </p>
              {/* Drop a Line Section */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-mail"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" />
                <path d="M3 7l9 6l9 -6" />
              </svg>
              <h2>Drop a Line</h2>
              <p>
                Drop us a line at{" "}
                <a href="mailto:awasthi.manjul@gmail.com">
                  awasthi.manjul@gmail.com
                </a>{" "}
                <br />
                and we'll get back soon.
              </p>
              {/* Visit Us Section */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-map-pin"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
              </svg>
              <h2>Visit Us</h2>
              <p>
                Manjul Awasthi,
                <br />
                GF-18, Shivani Plaza, Near Aliganj Hanuman Mandir,
                <br />
                Kapoorthala Crossing, Aliganj,
                <br />
                Lucknow, Uttar Pradesh-226024
              </p>
            </div>
          </div>

          {/* <div className="form-and-map"> */}
          {/*   <div className="map-section"> */}
          {/*     {!isMapLoaded && ( */}
          {/*       <div className="map-placeholder"> */}
          {/*         <img src={mapPlaceholder} alt="Loading map..." /> */}
          {/*       </div> */}
          {/*     )} */}
          {/*     <iframe */}
          {/*       title="Google Map" */}
          {/*       width="100%" */}
          {/*       height="500" */}
          {/*       src="https://maps.google.com/maps?width=100%&height=600&hl=en&q=Shivani%20Plaza%2C%20%20Near%20Aliganj%20Hanuman%20Mandir%2C%20Kapoorthala%20Crossing%2C%20%20Aliganj%20%20Lucknow%20%20Uttar%20Pradesh%20226024+(United%20Investment%20Point)&ie=UTF8&t=k&z=16&iwloc=B&output=embed" */}
          {/*       style={!isMapLoaded ? { display: "none" } : {}} */}
          {/*       onLoad={handleMapLoad} */}
          {/*     ></iframe> */}
          {/*   </div> */}
          {/**/}
          {/*   <div className="contact-form"> */}
          {/*     <h2>Your Request</h2> */}
          {/*     <form> */}
          {/*       <input type="text" id="Name" placeholder="Full Name" /> */}
          {/*       <input type="email" id="Email" placeholder="Email" /> */}
          {/*       <input type="text" id="Phone" placeholder="Phone" /> */}
          {/*       <select> */}
          {/*         <option value="Services">Services</option> */}
          {/*         <option value="Services1">Services1</option> */}
          {/*         <option value="Services2">Services2</option> */}
          {/*         <option value="Services3">Services3</option> */}
          {/*       </select> */}
          {/*       <textarea placeholder="Type in here ..."></textarea> */}
          {/*       <div className="form-buttons"> */}
          {/*         <button className="send" type="button"> */}
          {/*           Send Request */}
          {/*         </button> */}
          {/*       </div> */}
          {/*     </form> */}
          {/*   </div> */}
          {/* </div> */}
        </div>
      </div>
    </>
  );
};

export default ContactUs;
